export default "__VITE_ASSET__DHiDwv7Z__"